import * as React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import Edit from '@/assets/icons/edit.svg';
import { Button } from '@/components/ui/button';
import { Tab } from '@/components/ui/tab';
import { Typography } from '@/components/ui/typography';
import { useOpeningContext } from '@/contexts/opening-context';

import { GoalStatus } from './types';

interface StatusTabsProps {
  hireATHiringGoalUrl: string;
  activeTab: GoalStatus;
  setActiveTab: (status: GoalStatus) => void;
}

function StatusTabs({
  hireATHiringGoalUrl,
  activeTab,
  setActiveTab,
}: StatusTabsProps) {
  const intl = useIntl();
  const { openingTitle } = useOpeningContext();

  const handleTabClick = (
    status: GoalStatus,
    e: React.MouseEvent<HTMLAnchorElement>,
  ) => {
    e.preventDefault();
    setActiveTab(status);
  };

  return (
    <>
      <div className="flex items-center gap-4 self-stretch">
        <div className="grow">
          <Typography variant="h5">{openingTitle}</Typography>
        </div>
        <Button variant="secondary" asChild>
          <Link to={hireATHiringGoalUrl} target="_blank">
            <img src={Edit} alt="Edit" />
            <FormattedMessage defaultMessage="Edit goals" />
          </Link>
        </Button>
      </div>
      <div className="flex h-10 items-start gap-1">
        <Tab
          title={intl.formatMessage({ defaultMessage: 'Active' })}
          to=""
          isActive={activeTab === 'active'}
          onClick={e => handleTabClick('active', e)}
        />
        <Tab
          title={intl.formatMessage({ defaultMessage: 'Past' })}
          to=""
          isActive={activeTab === 'past'}
          onClick={e => handleTabClick('past', e)}
        />
        <Tab
          title={intl.formatMessage({ defaultMessage: 'Scheduled' })}
          to=""
          isActive={activeTab === 'scheduled'}
          onClick={e => handleTabClick('scheduled', e)}
        />
      </div>
    </>
  );
}

export { StatusTabs };
